import { Stack } from "@mui/material";
import { useMiscParams } from "hooks/search";
import { useTenantTranslation } from "hooks/formatters";
import { LoadedContent } from "src/components/common/loading/loadedContent";
import { LabelledSwitch, SwitchSkeleton } from "./suppressConstraints";

export const RoundedSolutionEditor = () => {
  const { t } = useTenantTranslation();
  const [miscParams, setMiscParams] = useMiscParams();

  return (
    <Stack sx={{ mt: 0.5 }} gap={0.5}>
      <LoadedContent
        data={miscParams}
        loading={<SwitchSkeleton />}
        waiting={<SwitchSkeleton />}
      >
        {(loaded) => (
          <LabelledSwitch
            label={t("integerSolution")}
            value={loaded.rounded_solution}
            setValue={(update) => {
              setMiscParams((current) => ({
                ...current,
                rounded_solution: update(current.rounded_solution),
              }));
            }}
          />
        )}
      </LoadedContent>
    </Stack>
  );
};
